import { defineNuxtRouteMiddleware } from '#app/composables/router';
import { decideLicenseLocked, LICENSE_LOCKED_ROUTE_NAME, useAuth } from '#layers/access/public';
import { useSystemInfo } from '#layers/base/public';
import { isUnderTest } from '~/utils/env/is-under-test';
import { isGuestOrPublicRoute } from '~/utils/routes';

/**
 * Redirects an authenticated user to `license.locked` when the instance license
 * is `locked`. Runs at boot regardless of middleware order: `loggedIn` resolves
 * eagerly and `license` is awaited here.
 *
 * Pre-checks mirror `decideLicenseLocked` to short-circuit before the auth probe.
 * A locked license outranks onboarding: `4.onboarding.global` stands down while locked.
 */
export default defineNuxtRouteMiddleware(async (to) => {
	const isUnderTestFlag = isUnderTest();
	const isGuestOrPublic = isGuestOrPublicRoute(to);
	const isLockPage = to.name === LICENSE_LOCKED_ROUTE_NAME;

	if (isUnderTestFlag || isGuestOrPublic || isLockPage) return;

	const systemInfo = useSystemInfo();
	const auth = useAuth();
	await Promise.all([auth.ensureInitialized(), systemInfo.ensureLoaded()]);

	return decideLicenseLocked({
		isUnderTest: isUnderTestFlag,
		isGuestOrPublicRoute: isGuestOrPublic,
		isLockPage,
		loggedIn: auth.loggedIn,
		licenseStatus: systemInfo.license.status,
		redirectPath: to.fullPath,
	});
});
